import React from 'react';
import { highlightText } from '@/utils/searchHighlight';

interface TextContentPreviewProps {
  content: string;
  maxLines?: number;
  searchQuery?: string;
}

const TextContentPreview: React.FC<TextContentPreviewProps> = ({ content, maxLines, searchQuery }) => {
  const display = maxLines
    ? content.split('\n').slice(0, maxLines).join('\n')
    : content;

  return (
    <div className="cursor-text break-words whitespace-pre-wrap">
      {highlightText(display, searchQuery)}
    </div>
  );
};

export default TextContentPreview;
